"use strict";

require("@patsnap-biz/design-tokens/scss/_button.scss");
require("@patsnap-biz/design-tokens/scss/_flex.scss");
require("@patsnap-biz/icon/lib/style");
require("@patsnap-biz/list/lib/style");
require("@patsnap-biz/header-widget/lib/style");
require("./avatar.scss");
require("./user_center_menu.scss");
require("./user_center.scss");
require("@patsnap-ui/icon/assets/solid/users.svg");
require("@patsnap-ui/icon/assets/solid/settings.svg");
require("@patsnap-ui/icon/assets/solid/TranslateEnglish.svg");
require("@patsnap-ui/icon/assets/solid/logout.svg");
require("@patsnap-ui/icon/assets/solid/profile.svg");
require("@patsnap-ui/icon/assets/solid/DropdownRight.svg");